import * as React from "react";
import styled from "styled-components";
import PageContainer from "../pageContainer";
import { graphql } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import { when } from "../../styles/theme.js";
import { useInView } from "react-intersection-observer";

export const fragment = graphql`
  fragment VisionMissionContent on ContentfulPageSectionVisionMission {
    title
    figureLineBottom1
    figureLineBottom2
    figureLineTop1
    figureLineTop2
    figureLogo1 {
      description
      gatsbyImageData(layout: CONSTRAINED, width: 48, height: 48)
    }
    figureLogo2 {
      description
      gatsbyImageData(layout: CONSTRAINED, width: 48, height: 48)
    }

    internal {
      type
    }
  }
`;

const Container = styled(PageContainer)`
  margin-top: 10rem;
  margin-bottom: 10rem;
`;

const InnerContainer = styled.div`
  ${when("sm")} {
    display: flex;
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 8rem;

  &:first-child {
    margin-top: 0;
  }

  ${when("sm")} {
    flex: 1;
    margin-top: 0;
    padding-top: 1rem;
    padding-bottom: 1rem;

    &:first-child {
      border-right: 1px solid ${(props) => props.theme.colors.darkGray};
    }
  }
`;

const ImageWrapper = styled.div``;

const Title = styled.h2`
  font-size: 3.6rem;
  margin: 1rem 0 0;
  color: ${(props) => props.theme.colors.darkBlue};
`;

const Description = styled.p`
  margin: 1rem 0 0;
  width: 70%;
  text-align: center;
  max-width: 32rem;

  ${when("sm")} {
    width: 80%;
  }
`;

const VisionMission = ({ data, setCurrentSection, index }) => {
  const { ref } = useInView({
    onChange: (inView) => {
      if (inView) {
        setCurrentSection(index);
      }
    },
    rootMargin: "-30% 0% -30% 0%",
  });

  return (
    <Container
      as={"section"}
      hasSideBar={true}
      ref={ref}
      id={`section-${index}`}
    >
      <InnerContainer>
        <Content>
          <ImageWrapper>
            <GatsbyImage
              alt={data.figureLogo1?.description}
              image={data.figureLogo1?.gatsbyImageData}
              objectFit={"contain"}
            />
          </ImageWrapper>
          <Title>{data.figureLineTop1}</Title>
          <Description>{data.figureLineBottom1}</Description>
        </Content>
        <Content>
          <ImageWrapper>
            <GatsbyImage
              alt={data.figureLogo2?.description}
              image={data.figureLogo2?.gatsbyImageData}
              objectFit={"contain"}
            />
          </ImageWrapper>
          <Title>{data.figureLineTop2}</Title>
          <Description>{data.figureLineBottom2}</Description>
        </Content>
      </InnerContainer>
    </Container>
  );
};

export default VisionMission;

export const visionMissionName = "ContentfulPageSectionVisionMission";
